import dayjs from 'dayjs'
import ScheduleSlotsToCalendarDataTransformer from 'transformers/ScheduleSlotsToCalendarDataTransformer'

const demoReferrals = [
    {
        id: 1,
        toUser: {
            id: 23,
            designation: 'MD',
            firstName: 'Demo',
            lastName: 'Demo',
            userRole: {
                id: 1,
                name: 'Physician',
            },
            avatar: {
                'thumb-360':
                    'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/thumb-360/733978a8-85d6-44dd-877f-bc91a9f9995b.png',
                source: 'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/source/733978a8-85d6-44dd-877f-bc91a9f9995b.png',
            },
            specialities: [
                {
                    speciality: {
                        id: 14,
                        name: 'Neurological Surgery',
                    },
                    subSpeciality: null,
                },
            ],
        },
        fromUser: {
            id: 1,
            designation: 'MD',
            firstName: 'Amos',
            lastName: 'Dare',
            userRole: {
                id: 1,
                name: 'Physician',
            },
            avatar: {
                'thumb-360':
                    'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/thumb-360/ee05bd9a-2a59-4713-a14b-500da1dfbe88.png',
                source: 'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/source/ee05bd9a-2a59-4713-a14b-500da1dfbe88.png',
            },
            specialities: [
                {
                    speciality: {
                        id: 14,
                        name: 'Neurological Surgery',
                    },
                    subSpeciality: null,
                },
                {
                    speciality: {
                        id: 14,
                        name: 'Neurological Surgery',
                    },
                    subSpeciality: null,
                },
            ],
        },
        createdDateTime: dayjs(new Date()).subtract(7, 'day').format('YYYY-MM-DDTHH:mm:ss'),
        appointmentDateTime: dayjs(new Date()).subtract(-1, 'day').format('YYYY-MM-DDTHH:mm:ss'),
        approveDateTime: dayjs(new Date()).subtract(3, 'day').format('YYYY-MM-DDTHH:mm:ss'),
        patientStatusDateTime: null,
        state: 'OPEN',
        status: 'CREATED',
        practiceLocation: null,
        patient: {
            firstName: 'Xxxx',
            lastName: 'Xxxxx',
            dateOfBirth: '1700-01-01',
        },
        shouldShowPatientInfo: false,
        practice: {
            id: 10,
            name: 'Amos O. Dare, MD, P.A.',
            practiceType: 'physician',
            image: {
                'thumb-360': null,
                source: null,
            },
        },
        fromPractice: {
            id: 1,
            name: 'Amos O. Dare, MD, P.A.',
            practiceType: 'physician',
            email: 'info@aodmdpa.com',
        },
        facilityServiceTests: [],
    },
]

const pendingReferral = {
    id: 2040,
    toUser: {
        id: 6413,
        designation: 'MD',
        firstName: 'Demo',
        lastName: 'Demo',
        userRole: {
            id: 1,
            name: 'Physician',
        },
        email: 'aodmdpa@gmail.com',
        phone: '3055140528',
        avatar: {
            'thumb-360':
                'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/thumb-360/733978a8-85d6-44dd-877f-bc91a9f9995b.png',
            source: 'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/source/733978a8-85d6-44dd-877f-bc91a9f9995b.png',
        },
        specialities: [
            {
                speciality: {
                    id: 14,
                    name: 'Neurological Surgery',
                },
                subSpeciality: {
                    id: 171,
                    name: 'General',
                },
            },
        ],
    },
    fromUser: {
        id: 1,
        designation: 'MD',
        firstName: 'Amos',
        lastName: 'Dare',
        userRole: {
            id: 1,
            name: 'Physician',
        },
        avatar: {
            'thumb-360':
                'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/thumb-360/ee05bd9a-2a59-4713-a14b-500da1dfbe88.png',
            source: 'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/source/ee05bd9a-2a59-4713-a14b-500da1dfbe88.png',
        },
        specialities: [
            {
                speciality: {
                    id: 14,
                    name: 'Neurological Surgery',
                },
                subSpeciality: {
                    id: 171,
                    name: 'General',
                },
            },
            {
                speciality: {
                    id: 14,
                    name: 'Neurological Surgery',
                },
                subSpeciality: {
                    id: 82,
                    name: 'Spine Surgery',
                },
            },
        ],
    },
    note: 'xxxXxxxxx xxxx xxx xxxxxxx xx xxxxxxx. Xxxxx xxx.xxxx',
    primaryCarePhysician: {
        id: 6094,
        designation: 'MD',
        name: 'Amos Dare',
        email: 'info@aodmdpa.com',
        phone: '9047439222',
        avatar: {
            'thumb-360':
                'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/thumb-360/ee05bd9a-2a59-4713-a14b-500da1dfbe88.png',
            source: 'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/source/ee05bd9a-2a59-4713-a14b-500da1dfbe88.png',
        },
    },
    createdDateTime: dayjs(new Date()).subtract(7, 'day').format('YYYY-MM-DDTHH:mm:ss'),
    appointmentDateTime: dayjs(new Date()).subtract(-1, 'day').format('YYYY-MM-DDTHH:mm:ss'),
    approveDateTime: null,
    state: 'OPEN',
    status: 'CREATED',
    diagnosis: 'Coronavirus infection, unspecified',
    insurancePlan: {
        id: 246,
        name: 'Self-pay',
    },
    isInsuranceAuthorizationRequired: false,
    isPrimaryCareOutsideMedmatch: false,
    patient: {
        id: 1556,
        firstName: 'Xxxx',
        lastName: 'Xxxxx',
        mobilePhone: 'xxxxxxxxxx',
        dateOfBirth: '1700-01-01',
        email: '',
    },
    insuranceAuthorizationObtainedDateTime: null,
    consultationNoteDateTime: null,
    fromReferralId: null,
    physicianReview: null,
    patientReview: null,
    consultationReports: null,
    referralNotes: null,
    attachments: [],
    speciality: {
        id: 14,
        name: 'Neurological Surgery',
        created_date: '2018-05-05T10:56:46.000Z',
    },
    practiceLocation: {
        zip: '33496',
        address: '1905 Clintmore Rd, Unit 300',
        name: 'Amos O. Dare, MD, P.A.',
        city: 'Boca Raton',
        state: 'FL',
    },
    shouldShowPatientInfo: false,
    closeReason: null,
    closeComment: null,
    patientStatusDateTime: null,
    notesRequestDateTime: null,
    insuranceAuthNumber: null,
    insuranceGroupNumber: '123',
    insuranceNumber: '123',
    practice: {
        id: 10,
        name: 'Amos O. Dare, MD, P.A.',
        practiceType: 'physician',
        email: 'info@aodmdpa.com',
    },
    fromPractice: {
        id: 1,
        name: 'Neurosurgery & Orthopedic Institute of Florida',
        practiceType: 'physician',
        email: 'info@aodmdpa.com',
    },
    facilityServiceTests: [],
}

const confirmedReferral = {
    id: 2040,
    toUser: {
        id: 6413,
        designation: 'MD',
        firstName: 'Demo',
        lastName: 'Demo',
        userRole: {
            id: 1,
            name: 'Physician',
        },
        email: 'stefanmihajlovic91pn+miha@gmail.com',
        phone: '3125202070',
        avatar: {
            'thumb-360':
                'https://medmatch-stage-s3-bucket-public.s3.amazonaws.com/photos/users/thumb-360/3136b86b-af54-49d2-a95e-26b797536116.png',
            source: 'https://medmatch-stage-s3-bucket-public.s3.amazonaws.com/photos/users/source/3136b86b-af54-49d2-a95e-26b797536116.png',
        },
        specialities: [
            {
                speciality: {
                    id: 8,
                    name: 'Allergy & Immunology',
                },
                subSpeciality: {
                    id: 165,
                    name: 'General',
                },
            },
        ],
    },
    fromUser: {
        id: 1,
        designation: 'MD',
        firstName: 'Amos',
        lastName: 'Dare',
        userRole: {
            id: 1,
            name: 'Physician',
        },
        avatar: {
            'thumb-360':
                'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/thumb-360/ee05bd9a-2a59-4713-a14b-500da1dfbe88.png',
            source: 'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/source/ee05bd9a-2a59-4713-a14b-500da1dfbe88.png',
        },
        specialities: [
            {
                speciality: {
                    id: 14,
                    name: 'Neurological Surgery',
                },
                subSpeciality: {
                    id: 171,
                    name: 'General',
                },
            },
            {
                speciality: {
                    id: 14,
                    name: 'Neurological Surgery',
                },
                subSpeciality: {
                    id: 82,
                    name: 'Spine Surgery',
                },
            },
        ],
    },
    note: null,
    primaryCarePhysician: {
        id: 6094,
        designation: 'MD',
        name: 'Amos Dare',
        email: 'info@aodmdpa.com',
        phone: '9047439222',
        avatar: {
            'thumb-360':
                'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/thumb-360/ee05bd9a-2a59-4713-a14b-500da1dfbe88.png',
            source: 'https://medmatch-prod-s3-bucket-public.s3.amazonaws.com/photos/users/source/ee05bd9a-2a59-4713-a14b-500da1dfbe88.png',
        },
    },
    createdDateTime: dayjs(new Date()).subtract(7, 'day').format('YYYY-MM-DDTHH:mm:ss'),
    appointmentDateTime: dayjs(new Date()).subtract(-1, 'day').format('YYYY-MM-DDTHH:mm:ss'),
    approveDateTime: dayjs(new Date()),
    state: 'OPEN',
    status: 'PATIENT_VISIT_PENDING',
    diagnosis: 'Coronavirus infection, unspecified',
    insurancePlan: {
        id: 246,
        name: 'Self-pay',
    },
    isInsuranceAuthorizationRequired: false,
    isPrimaryCareOutsideMedmatch: false,
    patient: {
        id: 54,
        firstName: 'Smith',
        lastName: 'John',
        mobilePhone: '4804401532',
        dateOfBirth: '1968-02-12',
        email: '',
    },
    insuranceAuthorizationObtainedDateTime: null,
    consultationNoteDateTime: null,
    fromReferralId: null,
    physicianReview: null,
    patientReview: null,
    consultationReports: null,
    referralNotes: [
        {
            note: 'Test report( Brief Neuro)_Redacted.pdf',
            url: 'https://api.medmatchnetwork.com/uploads/consultation-notes/79/223a98b5-0379-4bad-94a2-3746e3f995ef.pdf',
            extension: 'pdf',
        },
    ],
    attachments: [],
    speciality: {
        id: 14,
        name: 'Neurological Surgery',
        created_date: '2018-05-05T10:56:46.000Z',
    },
    practiceLocation: {
        zip: '33496',
        address: '1905 Clintmore Rd, Unit 300',
        name: 'Amos O. Dare, MD, P.A.',
        city: 'Boca Raton',
        state: 'FL',
    },
    shouldShowPatientInfo: true,
    closeReason: null,
    closeComment: null,
    patientStatusDateTime: null,
    notesRequestDateTime: null,
    insuranceAuthNumber: null,
    insuranceGroupNumber: '123',
    insuranceNumber: '123',
    practice: {
        id: 10,
        name: 'Amos O. Dare, MD, P.A.',
        practiceType: 'physician',
        email: 'info@aodmdpa.com',
    },
    fromPractice: {
        id: 1,
        name: 'Neurosurgery & Orthopedic Institute of Florida',
        practiceType: 'physician',
        email: 'info@aodmdpa.com',
    },
    facilityServiceTests: [],
}

const slots = [
    {
        date: '2024-08-25',
        startTime: '07:00',
        endTime: '07:15',
    },
    {
        date: '2024-08-25',
        startTime: '07:15',
        endTime: '07:30',
    },
    {
        date: '2024-08-25',
        startTime: '07:30',
        endTime: '07:45',
    },
    {
        date: '2024-08-25',
        startTime: '07:45',
        endTime: '08:00',
    },
    {
        date: '2024-08-25',
        startTime: '08:00',
        endTime: '08:15',
    },
    {
        date: '2024-08-25',
        startTime: '08:15',
        endTime: '08:30',
    },
    {
        date: '2024-08-25',
        startTime: '08:30',
        endTime: '08:45',
    },
    {
        date: '2024-08-25',
        startTime: '08:45',
        endTime: '09:00',
    },
    {
        date: '2024-08-25',
        startTime: '09:00',
        endTime: '09:15',
    },
    {
        date: '2024-08-25',
        startTime: '09:15',
        endTime: '09:30',
    },
    {
        date: '2024-08-25',
        startTime: '09:30',
        endTime: '09:45',
    },
    {
        date: '2024-08-25',
        startTime: '09:45',
        endTime: '10:00',
    },
    {
        date: '2024-08-25',
        startTime: '10:00',
        endTime: '10:15',
    },
    {
        date: '2024-08-25',
        startTime: '10:15',
        endTime: '10:30',
    },
    {
        date: '2024-08-25',
        startTime: '10:30',
        endTime: '10:45',
    },
    {
        date: '2024-08-25',
        startTime: '10:45',
        endTime: '11:00',
    },
    {
        date: '2024-08-25',
        startTime: '11:00',
        endTime: '11:15',
    },
    {
        date: '2024-08-25',
        startTime: '11:15',
        endTime: '11:30',
    },
    {
        date: '2024-08-25',
        startTime: '11:30',
        endTime: '11:45',
    },
    {
        date: '2024-08-25',
        startTime: '11:45',
        endTime: '12:00',
    },
    {
        date: '2024-08-25',
        startTime: '12:00',
        endTime: '12:15',
    },
    {
        date: '2024-08-25',
        startTime: '12:15',
        endTime: '12:30',
    },
    {
        date: '2024-08-25',
        startTime: '12:30',
        endTime: '12:45',
    },
    {
        date: '2024-08-25',
        startTime: '12:45',
        endTime: '13:00',
    },
    {
        date: '2024-08-25',
        startTime: '13:00',
        endTime: '13:15',
    },
    {
        date: '2024-08-25',
        startTime: '13:15',
        endTime: '13:30',
    },
    {
        date: '2024-08-25',
        startTime: '13:30',
        endTime: '13:45',
    },
    {
        date: '2024-08-25',
        startTime: '13:45',
        endTime: '14:00',
    },
    {
        date: '2024-08-25',
        startTime: '14:00',
        endTime: '14:15',
    },
    {
        date: '2024-08-25',
        startTime: '14:15',
        endTime: '14:30',
    },
    {
        date: '2024-08-25',
        startTime: '14:30',
        endTime: '14:45',
    },
    {
        date: '2024-08-25',
        startTime: '14:45',
        endTime: '15:00',
    },
    {
        date: '2024-08-25',
        startTime: '15:00',
        endTime: '15:15',
    },
    {
        date: '2024-08-25',
        startTime: '15:15',
        endTime: '15:30',
    },
    {
        date: '2024-08-25',
        startTime: '15:30',
        endTime: '15:45',
    },
    {
        date: '2024-08-25',
        startTime: '15:45',
        endTime: '16:00',
    },
    {
        date: '2024-08-25',
        startTime: '16:00',
        endTime: '16:15',
    },
    {
        date: '2024-08-25',
        startTime: '16:15',
        endTime: '16:30',
    },
    {
        date: '2024-08-25',
        startTime: '16:30',
        endTime: '16:45',
    },
    {
        date: '2024-08-25',
        startTime: '16:45',
        endTime: '17:00',
    },
    {
        date: '2024-08-25',
        startTime: '17:00',
        endTime: '17:15',
    },
    {
        date: '2024-08-25',
        startTime: '17:15',
        endTime: '17:30',
    },
    {
        date: '2024-08-25',
        startTime: '17:30',
        endTime: '17:45',
    },
    {
        date: '2024-08-25',
        startTime: '17:45',
        endTime: '18:00',
    },
    {
        date: '2024-08-25',
        startTime: '18:00',
        endTime: '18:15',
    },
    {
        date: '2024-08-25',
        startTime: '18:15',
        endTime: '18:30',
    },
    {
        date: '2024-08-25',
        startTime: '18:30',
        endTime: '18:45',
    },
    {
        date: '2024-08-25',
        startTime: '18:45',
        endTime: '19:00',
    },
]

export default {
    getDemoReferral() {
        return demoReferrals
    },

    getPendingReferral() {
        return pendingReferral
    },

    getConfirmedReferral() {
        return confirmedReferral
    },

    getSlots() {
        return ScheduleSlotsToCalendarDataTransformer.transform(JSON.stringify(slots))
    },
}
